import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, uaeProjectsBaseURL } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_RECENT_SEARCHES, GET_RECENT_SEARCHES_ERROR, GET_RECENT_SEARCHES_SUCCESS } from '../../actions';
import { Constant } from '../../../../../Containers/Helpers/constant.js';

function* getRecentSearches({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/v1/recent-searches`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
      },
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_RECENT_SEARCHES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_RECENT_SEARCHES_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_RECENT_SEARCHES_ERROR, payload: error });
  }
}

export function* watchGetRecentSearches() {
  yield takeEvery(GET_RECENT_SEARCHES, getRecentSearches);
}

function* getRecentSearchesSaga() {
  yield all([fork(watchGetRecentSearches)]);
}

export default getRecentSearchesSaga;
